import * as types from 'actions/actionTypes';
import initialState from '../initialState';

/**
 * reducer per gestire le interrogazioni a crashboxx - download single pdf
 * @param {*} state
 * @param {*} action
 */
export default function crashboxxDownloadSinglePdfReducer(state = initialState.crashboxxFiles.singlePdf, action){

    switch(action.type)
    {
        case types.DOWNLOAD_SINGLEPDF_REQUEST:
            return {...state, error: null, isLoading: true};
        case types.DOWNLOAD_SINGLEPDF_SUCCESS:
            return {...state, error: null, isLoading: false};
        case types.DOWNLOAD_SINGLEPDF_ERROR:
            return {...state, error: action.error, isLoading: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/crashboxx/crashboxxDownloadSinglePdfReducer.js